import { Injectable, NgZone } from '@angular/core';
import { Observable } from 'rxjs';

interface IWindow extends Window {
	webkitSpeechRecognition: any;
}



@Injectable({
  providedIn: 'root'
})
export class SpeechService {

	recognition: any;

	constructor(private zone: NgZone) { }

	record(lang: string): Observable<string> {
		return Observable.create(observe => {



			const { webkitSpeechRecognition }: IWindow = (window as unknown as IWindow);
			this.recognition = new webkitSpeechRecognition();

//			this.recognition.maxAlternatives = 10;
			this.recognition.continuous = false;
			this.recognition.interimResults = true;
/*			
			this.recognition.onresult = take => this.zone.run(() =>
					observe.next( {action:'result', data:  take.results.item(take.results.length - 1).item(0).transcript})
			);
*/


			this.recognition.onresult = (event: any) => {
				let interimTranscript = '';
				let finalTranscript = '';
				for (let i = event.resultIndex, len = event.results.length; i < len; i++) {
				  let transcript = event.results[i][0].transcript;
				  if (event.results[i].isFinal) {
					finalTranscript += transcript;
				  } else {
					interimTranscript += transcript;
				  }
				}


				if(finalTranscript!=''){
					observe.next({action:'result', data : finalTranscript});
				}else{
					//observe.next({action:'processing', data : interimTranscript});
				}
				 
				}

	
			this.recognition.onerror = err => observe.error(err);
			this.recognition.onend = () => observe.complete();
			this.recognition.onsoundstart = () => observe.next({action:'soundstart', data : null});
			this.recognition.onsoundend = () => observe.next({action:'soundend', data : null});
			
			this.recognition.lang = lang;
			this.recognition.start();
		});
	}
	stoprecord() {
		if (this.recognition) {
			this.recognition.stop();
		}
	}


	checkAvailability(): boolean{


		if (!('webkitSpeechRecognition' in window)) {
			return false;
		  } else {
			return true;
		  }

/*

		const { webkitSpeechRecognition }: IWindow = (window as unknown as IWindow);

		let recognitionWebkit = new webkitSpeechRecognition();

		if ( recognitionWebkit == undefined){
			return false;
		}else{
			return true;
		}

*/

	}
}
